<template>
     <Scroll :on-reach-bottom="handleReachBottom" height="650" :distance-to-edge=[-20,0]>
    <div class="kucun">
                <div class="topBar">
                    <div class="daohang">
                            <span @click="tiaozhuan" style="cursor: pointer; font-size:20px;color:#2d8cf0;font-family:'微软雅黑' "><Icon type="ios-home"></Icon>{{language.shouye}}</span>>
                            <span style="cursor: pointer; font-size:20px;font-family:'微软雅黑'">{{language.tihuojihua}}</span>
                        </div>
            <div class="iptc">
                <div class="iptlis">
                    <Icon type="ios-search" class='ico'></Icon>
                    <input  class="iptli" :placeholder=language.chaxunqingdianjiwo type="primary" @click="modal1 = true">
                    <div class="numEve">
                      <div class="numlitter">{{language.gong}}{{numnum}}{{language.tiao}}</div></div>
                </div>
            </div>
        </div>
        <modal class="serchlist"  v-model="modal1"
         width="86%" height="50%" :styles="{top: '60px',left:'100px'}">
            <div class="pz">
                <Select :placeholder=language.qingxuanze type="text" v-model="numpinzhong" clearable style="width: 200px">
                    <Option v-for="item in selectDatta" :value="item" :key="item"></Option>
                </Select>
                <span class='pinzhongs'>{{language.pinzhong}}</span>
            </div>
            <div class="ph">
                <Select :placeholder=language.qingxuanze type="text" filterable v-model="numpaihao" clearable style="width: 200px">
                    <Option v-for="item in shopDatta" :value="item" :key="item"></Option>
                </Select>
                <span class='paihaos'>{{language.paihao}}</span>
            </div>
            <div class="hou">
                <Input type="text" v-model="numhou" clearable style="width: 200px"></Input>
                <span class='hous'>{{language.hou}}</span>
            </div>
            <div class="kuan">
                <Input type="text" v-model="numkuan" clearable style="width: 200px"></Input>
                <span class='kuans'>{{language.kuan}}</span>
            </div>
            <div class="chang">
                <Input type="text" v-model="numchang" clearable style="width: 200px"></Input>
                <span class='changs'>{{language.chang}}</span>
            </div>
            <div class="ck">
                <Select :placeholder=language.qingxuanze type="text" v-model="numcangku" clearable style="width: 200px">
                    <Option v-for="item in  wareDatta" :value="item" :key="item"></Option>
                </Select>
                <span class='cangkus'>{{language.cangku}}</span>
            </div>
            <div class="kunb">
                <Input type="text" v-model="numkunbaohao" clearable style="width: 200px"></Input>
                <span class='kunbaohaos'>{{language.kunbaohao}}</span>
            </div>
            <div class="chanpinyuanliao">

                <Select :placeholder=language.qingxuanze name="" id="" v-model="cpyl" clearable style="width: 200px">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{item.label}}</Option>
                    <!-- <Option lable="生成订单" value="60">{{language.shengchengdingdan}}</Option> -->
                    <!-- <Option lable="撤销成功" value="00">{{language.chexiaochenggong}}</Option> -->
                   <!--  <Option label='撤销成功' value="00">撤销成功</Option>
                    <Option label='待审批' value="20">待审批</Option>
                    <Option label='业务员审批成功' value="30">业务员审批成功</Option>
                    <Option label='部分审批' value="02">部分审批</Option>
                    <Option label='业务员审批不通过' value="03">业务员审批不通过</Option>
                    <Option label='系统审批不通过' value="01">系统审批不通过</Option> -->
                </Select>
                <span>{{language.shenqingzhuangtai}}</span>
            </div>
<!--             <div class="chanpinyuanliao">
                <Select :placeholder=language.qingxuanze name="" id="" v-model="cpyl" clearable style="width: 200px">
                    <Option label="原料" value="MATERIAL">原料</Option>
                    <Option label="仓储" value="PRODUCT">成品</Option>
                </Select>
                <span class='cunhuo'>存货性质</span>
            </div>   -->
            <div class="muj">
                <!-- <DatePicker confirm type="daterange" v-model='paramssubData' format="yyyy/MM/dd"  placement="bottom-end" placeholder="Select date" style="width: 200px" @on-change="getDateTime"></DatePicker> -->
                <DatePicker type="daterange" v-model="paramssubData" @on-change="getDateTime" placeholder="Select date" style="width: 200px" class="dataipt"></DatePicker>
                <span>{{language.jiaohuoqujian}}</span>
            </div>
            <div class="ck">
                <Select :placeholder=language.qingxuanze type="text" v-model="chukuzhuangtai" clearable style="width: 200px">
                    <Option v-for="item in cityList2" :value="item.value" :key="item.value">{{item.label}}</Option>
  <!--                   <Option lable="未出库" value="10">{{language.weichuku}}</Option>
                    <Option lable="部分出库" value="20">{{language.bufenchuku}}</Option>
                    <Option lable="已出库" value="30">{{language.yichuku}}</Option> -->
                </Select>
                <span class='cangkus'>{{language.chukuzhuangtai}}</span>
            </div>
            <div class="mujuan">
                <Input type="text" v-model="mujuanchaxun" clearable style="width: 200px"></Input>
                <span>{{language.mujuanhao}}</span>
            </div>
            <div class="guige">
                <Input type="text" v-model="guige" clearable style="width: 200px"></Input>
                <span>{{language.mujuanguige}}</span>
            </div>
            <div slot="footer" style="background-color:rgb(249,249,249);height: 120px;">
                <div class="chaxun" @click='chaxun()'>{{language.chaxun}}</div>
                <div class="chongzhi" @click='chongzhis()'>{{language.chongzhi}}</div>
            </div>

         </modal>














    <Table border :columns="columns1" :data="numbewdata"></Table>
    <Col class="demo-spin-col" span="24" v-show="jiazai">
                    <Spin fix>
                        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                        <div>Loading</div>
                    </Spin>
                </Col>
    <div class="add_more_data">
        
<!--             <p class="add_more_data_btn" v-show="moredata">
              {{language.jiazaigengduo}}
            </p> -->
            <p class="add_more_data_btn" v-show="!moredata">
              {{language.jiazaiwanbi}}
            </p>
        </div>
   <!--  <div class="add_more_down_load">
        <p class="add_more_all_weight">合计： <span class="add_more_all_weight_span">{{resl}}</span>kg</p>
        <p class="add_more_add_more_down_load_btn" @click="downLoadData">

                <Icon type="archive" class="down"></Icon>
        数据下载
        </p>
    </div> -->


        <div class="bootBanner">
            <p class="liang">
                <!-- <span class="button_plan" @click="addTitles">
                    <span  style="margin-right:50px;"><Icon type="ios-compose"></Icon>提货</span>
                </span> -->
                       <span class="add_more_all_weight">{{language.heji}}： <div class="add_more_all_weight_span">{{resl}}</div>kg</span>
        <span class="add_more_add_more_down_load_btn" @click="downLoadData">

                <Icon type="archive" class="down"></Icon>
        {{language.shujuxiazai}}
        </span>

            </p>
    </div>
        <!-- <button @click="ApplyLine">主表渲染</button> -->
    </div>
    </Scroll>
</template>
<style scoped>
    .ivu-table-body .ivu-table-overflowX{
    overflow-x: none !important;
    }
    .kucun{
    margin-bottom: 90px;
    }
    .bootBanner{
    overflow:hidden;
    min-width:100%;
    margin-top:50px;
    position: fixed;
    bottom:-5px;
    margin-top:30px;
    z-index: 10;
    /*height: 70px;*/
    overflow:hidden;
    margin-top:300px;
    }
    .bootBanner span span{
    float: right;
    width:120px;
    height:70px;
    line-height: 70px;
    border: 1px solid #ccc;
    text-align:center;
    background-color:#1d92be;
    cursor:pointer;
    font-size: 18px;
    margin-right: 5px;
    display: block;
    }
    /*.boo*/
    .bootBanner .ivu-icon{
    margin-right:5px;
    color: #ffffff;
    font-size: 20px;
    }
    .bootBanner .liang{
    background-color:#e5ebf2;
    display: block;
    /*width: %;*/
    height: 100px;
    margin-right:150px;
    /*margin-top:30px;*/
    /*position: fixed;*/
    /*bottom: -10px;*/
    /*margin-right: 20px;*/

    }
    .serchlist .pz span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .chanpinyuanliao span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    } 
    .serchlist .pz,.ph,.hou,.kuan,.chang,.ck,.kunb,.muj,.chanpinyuanliao,.mujuan,.guige{
    position: relative;
    /*float: left;*/
    margin-left: 100px;
    margin-top: 20px;
    display: inline-block;
    }
    .serchlist .ph span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .guige span{
    position: absolute;
    width: 60px;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .mujuan span{
    width: 80px;
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .hou span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .kuan span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .chang span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .ck span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    width: 80px;
    }
    .serchlist .kunb span{
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .serchlist .muj span{
    width: 60px;
    position: absolute;
    height:20px;
    left: 10px;
    top:-15px;
    }
    .topBar{
    position: relative;
    }
    .numlitter{
    margin-right: 20px;
    }

    .iptlis{
    position: relative;
    }
    .iptlis .ico{
    position: absolute;
    right: 288px;
    top:23px;
    z-index: 11111; 
    }
    .daohang{
    position: absolute;
    top:10px;
    left: 10px;
    z-index: 10;
    }
    .iptli{
    width:150px;
    border:none;
    height: 24px; 
    position: absolute;
    right: 158px;
    top:18px;
    cursor: pointer;
    background-color: #eaeaea;
    padding-left:30px;
    /*box-shadow: 3px 6px 6px 2px #E6E3F5;*/
    text-align:left;
    border-radius: 3px;
    z-index: 10;
    /*border-shadow:3px 6px;*/
    /*position: relative;*/
    }
    .iptc{
    height: 65px;
    /*        border-bottom: 1px solid #dddddd;
    border-top: 1px solid #dddddd;*/
    position: relative;
    background:url(../assets/header.gif)repeat-x 0 0px;
    background-color: #cdd9e8;
    border-color: #8ba0bc;
    }

    .topBar{
    position: relative;
    }
    .daohang{
    position: absolute;
    top:10px;
    left: 10px;
    z-index: 10;
    }
    .down{
    width:30px;
    height:30px;
    position:absolute;
    top:20px;
    right:40px;
    /*font-size: 400px;*/
    /*background-color:#fff;*/
    }
    .chaxun,.chongzhi{
    width:120px;
    height: 40px;
    background-color:#1d92be;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    color: #f5f5f5;
    margin-top: 40px;
    display: inline-block;
    margin-right: 350px;
    }

    .numEve{
    position: absolute;
    right: 61px;
    top:15px;
    line-height: 30px;
    background-color:#ffffff;
    height: 30px;
    width: 250px;
    text-align: right;
    color: #0066ff;
    }

    /*    .iptc{
    height: 40px;
    position: relative;
    }*/

    .serchlist input{
    width:180px;
    height: 40px;
    /*margin-top:30px;*/
    text-align: center;
    border:1px solid #ccc;
    border-radius:5px;
    }
    .serchlist span{
    width:50px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    background-color: white;
    }

    .add_more_data{
    width:100%;
    height:60px;
    position: relative;
    }
    .add_more_data_btn{
    /*width:150px;*/
    height:40px;
    line-height:40px;
    position: absolute;
    top: 5px;
    left:50%;
    transform: translateX(-50%);
    text-align:center;
    cursor:pointer;
    }
    .add_more_data_btn:hover{
    color:#2d8cf0;
    }
    .ivu-table-wrapper{
    width:100%;
    border:none;        
    }
    .ivu-table table{
    table-layout:auto;
    }
    .ivu-table-tip{
    overflow:hidden;
    }
    .classtit{
    height: 30px;
    /*line-height: 30px;*/
    /*border-bottom: 1px solid #2d8cf0;*/
    }
    .classtit div{
    color:#2d8cf0;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-bottom:2px solid #2d8cf0;
    width:100px;
    }
    .classtit{
    height: 30px;
    /*line-height: 30px;*/
    /*border-bottom: 1px solid #2d8cf0;*/
    }
    .classtit div{
    color:#2d8cf0;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-bottom:2px solid #2d8cf0;
    width:150px;
    }
    .classtit:hover{
    color:blue;
    }
    .ivu_new_padding .ivu-table-expanded-cell{
    /*padding: 10px;*/
    /*padding: 0px !important;*/
    /*background-color:blue !important;*/

    }
    .kucun .daohang{
    margin-left: 20px;
    margin-top:10px;
    }
    .add_more_down_load{
    width:100%;
    height:100px;
    position: relative;
    background-color:#e5ebf2;
    bottom:-20px;
    }
    .add_more_all_weight{
    width:250px;
    height:80px;
    line-height:100px;
    position: absolute;
    top: 5px;
    left:5px;
    text-align:center;
    background-color:#e5ebf2;
    }
    .add_more_all_weight_span{
    color:red;
    display: inline-block;
    }
    .add_more_add_more_down_load_btn{
    width:120px;
    height:100px;
    line-height:100px;
    float: right;
    margin-right: 60px;
    position: relative;
    /*display: inline-block;*/
    /*position: absolute;*/
    /*top: 0px;*/
    /*right:8px;*/
    text-align:center;
    cursor:pointer;
    background-color:#1d92be;
    color:#fff;
    }
    .add_more_add_more_down_load_btn_span{
    width:30px;
    height:30px;
    position:absolute;
    top:25px;
    right:35px;
    background-color:#fff;
    }
</style>
<script>
    import axios from 'axios';
    import config from 'config/apiConfig'
    import language from "api/language"
    export default {
        data () {
            return {
                language:{},
                cityList2: [
                    {
                        value: '10',
                        label:language.weichuku,
                    },
                    {
                        value: '20',
                        label: language.bufenchuku,
                    },
                    {
                        value: '30',
                        label: language.yichuku,
                    },
                    ],
                 cityList: [
                    {
                        value: '60',
                        label: language.shengchengdingdan,
                    },
                    {
                        value: '00',
                        label: language.chexiaochenggong,
                    },
                    ],

                columns1: [
                {
                        title: language.shouhuokehu,
                        align:'center',
                        minWidth:70,
                        key: 'customerName'
                    },
                    {
                        title: language.cangku,
                        align:'center',
                        minWidth:70,
                        key: 'warehouseName'
                    },
                    {
                        title: language.danjuhao,
                        align:'center',
                        minWidth:100,
                        key: 'saleNoticeNo'
                    },
                    {
                        title: language.kunbaohao,
                        align:'center',
                        minWidth:110,
                        key: 'serialCode'
                    },
                    {
                        title: language.pinzhong,
                        align:'center',
                        minWidth:70,
                        key: 'categoryCode'
                    },
                    {
                        title: language.paihao,
                        align:'center',
                        minWidth:95,
                        key: 'shopsign'
                    },
                    {
                        title: language.guige,
                        align:'center',
                        minWidth:100,
                        key: 'specification'
                    },
                    
                    {
                        title: language.shuliang,
                        align:'center',
                        minWidth:70,
                        key: 'secondQty'
                    },
                    {
                        title: language.shuliang,
                        align:'center',
                        minWidth:70,
                        key: 'primaryQty'
                    },
                    {
                        title: language.neiwaiban,
                        align:'center',
                        minWidth:80,
                        key: 'exposedName'
                    },
                    {
                        title: language.rukuriqi,
                        align:'center',
                        minWidth:80,
                        key: 'stockInDate'
                    },
                    {
                        title: language.jiaohuoqi,
                        align:'center',
                        minWidth:80,
                        key: 'outDeliveryDate'
                    },
                    {
                        title: language.shenpizhuangtai,
                        align:'center',
                        minWidth:100,
                        key: 'applyStatusName'
                    },
                    {
                        title: language.chukuzhuangtai,
                        align:'center',
                        minWidth:100,
                        key: 'outStatusName'
                    },
                    {
                        title: language.beizhu,
                        align:'center',
                        minWidth:70,
                        key: 'remarks'
                    },
                    {
                        title: language.caozuo,
                        key: 'fsuffix',
                        align:'center',
                        minWidth:100,
                        render: (h, params) => {
                            return h('div', [
                                   h('Button', {
                                    on:{
                                        click:()=>{
                                            this.addCart(params)
                                        }
                                    },
                                    style:{
                                        border:'none',
                                        backgroundColor:'white',
                                        // color:'blue',
                                        fontSize:'15px'
                                    }
                                },
                                [h('icon',{
                                    props:{
                                        type:'ios-cart'
                                    },
                                    style:{
                                        // marginLeft:"-10px",
                                        // textAlign:"center"
                                        // lineHeight:"10px"
                                    },
                                })]
                                ),
                                 h('Button', {
                                    on:{
                                        click:()=>{
                                            this.removelist(params)
                                        }
                                    },
                                      style:{
                                        border:'none',
                                        backgroundColor:'white',
                                        // color:'blue',
                                        fontSize:'15px'
                                    },
                                },
                                [h('icon',{
                                    props:{
                                        type:'reply-all'
                                    },
                                    style:{
                                        fontSize:16

                                        // marginLeft:"-10px",
                                        // textAlign:"center"
                                    },
                                })]
                                ), 


                                h('strong', params.row.name)
                            ]);
                            // console.log(row)
                            // if(params.row.applyStatus==20){
                            //     return h('div', [

                            //     h('Button', {
                            //         props: {
                            //             size: 'small'
                            //         },
                            //         style:{
                            //             border:'none',
                            //             backgroundColor:'#fff',
                            //             // margin:"0 auto"
                            //             fontSize:"20px"
                            //         },
                            //         on:{
                            //             click: ()=>{
                            //                 this.removelist(params)
                            //                 // alert(111)
                            //             }
                            //         }
                            //     },[
                            //         h('Icon', {
                            //             props: {
                            //                 type: "reply-all"
                            //             }
                            //         })

                            //     ])
                            // ]);
                            // }else if(params.row.applyStatus==60){
                            //     return h('div', [

                            //     h('Button', {
                            //         props: {
                            //             size: 'small'
                            //         },
                            //         style:{
                            //             border:'none',
                            //             backgroundColor:'#fff',
                            //             // margin:"0 auto"
                            //             fontSize:"20px"
                            //         },
                            //         on:{
                            //             click: ()=>{
                            //                 this.addCart(params)
                            //                 // alert(111)
                            //             }
                            //         }
                            //     },[
                            //         h('Icon', {
                            //             props: {
                            //                 type: "ios-cart"
                            //             }
                            //         })

                            //     ])
                            // ]);
                            // }
                            
                        }
                    },
                ],
                numbewdata:[],
                resl:0,
                data1: [],
                loadnum:[],
                addMoreData:true,
                numpinzhong:'',
                paramssubData:'',
                subData:'',
                subData2:'',
                numpaihao:'',
                numhou:'',
                numchang:'',
                numkuan:'',
                numcangku:'',
                numkunbaohao:'',
                cpyl:'',
                numnum:'',
                orderNum:'',
                packNumK:'',
                prodCode:'',
                modal1:false,
                selectDatta:[],
                shopDatta:[],
                outStatusData:'',
                wareDatta:[],
                chukuzhuangtai:'',
                mujuanchaxun:'',
                guige:'',
                moredata:true,
                jiazai:false,
                // subData:'',
            }
        },
        methods:{
        handleReachBottom(){
            return new Promise(update => {
                    setTimeout(() => {
                        let that=this;
               // if(indexs = 1){
               let paramsData;
                paramsData = {
                        "offset":"10",
                        "limit":"10",
                        "deliveryPlan":"10",
                        "categoryCode" : that.numpinzhong,
                        "shopsign" : that.numpaihao,
                        "thickness" : that.numhou,
                        "length" : that.numchang,
                        "width" : that.numkuan,
                        "warehouseName" : that.numcangku,
                        "serialCode" : that.numkunbaohao,
                        "applyStatus" : that.cpyl,
                        "outStatus":that.chukuzhuangtai,
                        "reelNo":that.mujuanchaxun,
                        "rawPieceSpecdesc":that.guige,
// 
                        "stockDateFrom" :that.paramssubData.subData,
                        "stockDateTo" :that.paramssubData.subData2,
                        // "applyStatus" : that.cpyl,
                        // "applyStatus" : that.cpyl,
                        // "deliveryPlan":"10"
                    }
                    // paramsData.stockDateFrom=that.paramssubData.subData;
                    // paramsData.stockDateTo=that.paramssubData.subData2;
                    // console.log(paramsData)
                  if(that.numbewdata.length%10 != 0){ that.moredata=false;that.jiazai=false; return;}
                  // return;
                  if(that.totalPageCount%10 == 0 && that.numbewdata.length == that.totalPageCount){ that.moredata=false;that.jiazai=false; return;}
                        that.jiazai=true
                 
                axios.post(config.queryOntOutApplyLine,paramsData).then(
                        function(response){ 
                    update();

                            if(response.data.resultCode == 1){
                                that.jiazai=false
                                // console.log(response)
                            that.numbewdata = that.numbewdata.concat(response.data.resultData.productList);
                            that.resl=response.data.page.totalWeight
                            that.$Message.info(language.jiazaiwanbi)
                            
                            }else{
                            that.$Message.info(response.data.fsuffix)
                            }
                           
                        })
                // return
                    },500);
                });
        },
        addCart(params){
            // console.log(params)
            // let data3="";
            // let data4=[];
            let serial=[params.row.serialCode]
            let paramsData={
             "productSerialCodes":serial

            }
            let that = this
            axios.post(config.addCartByJgs,paramsData).then(function(response){
                if(response.data.resultCode==0){
                   // that.$Modal.info({

                   //          // title: title,
                   //          content: "添加购物车成功，请到提货申请购物车查看！"
                        
                   //    })
                    that.$Message.info(response.data.resultMsgDetail)
                    }else{
                      // alert("添加购物车成功，请到提货申请购物车查看！")
                      that.$Modal.info({

                            // title: title,
                            content: response.data.resultMsgDetail
                        
                      })
                    }
            })
        },
        getDateTime(value){
            let that = this 
            // let subData=''
            // let subData2=''
            // let that = this
            // for(var i=0;i<value.length;i++){
            // console.log(value[i])
             that.paramssubData.subData=value[0]
             that.paramssubData.subData2=value[1]
            // }
                // console.log(that.paramssubData.subData)
                // console.log(that.paramssubData.subData2)
            },
         warehouseNameDrop(){
            let that = this
            axios.post(config.warehouseNameDrop,{}).then(function(response){
               let resultDatas=response.data.resultData
                for(var i=0;i<resultDatas.length;i++){
                    if(resultDatas[i].warehouseName!=null){
                    that.wareDatta.push(resultDatas[i].warehouseName)

                    }
                    // console.log(resultData[i].categoryCode)
                    // console.log(response)
                }
            })
        },
        shopsignDrop(){
            let that = this;
            axios.post(config.shopsignDrop,{}).then(function(response){
                // console.log(1)
                // console.log(response.data.resultData)
                let resultDatas=response.data.resultData
                for(var i=0;i<resultDatas.length;i++){
                    if(resultDatas[i].shopsign!=null){
                    that.shopDatta.push(resultDatas[i].shopsign)

                    }
                    // console.log(resultData[i].categoryCode)
                    // console.log(that.shopDatta)
                }
            })
        },
        selectType(){
            let that = this;
            axios.post(config.categoryCodeDrop,{}).then(function(response){
                // console.log(response.data.resultData)
                let resultData=response.data.resultData
                for(var i=0;i<resultData.length;i++){
                    if(resultData[i].categoryCode!=null){
                        that.selectDatta.push(resultData[i].categoryCode)
                    }
                    // console.log(resultData[i].categoryCode)
                    // console.log(that.selectDatta)
                }
            })
        },
            ApplyLine(response){
                let that = this
                that.language=language
                axios.post(config.queryOntOutApplyLine,{'deliveryPlan':'10'}).then(function(response){
                        if(response.data.page != null){
                        that.numbewdata=response.data.resultData.productList;
                        that.resl=response.data.page.totalWeight
                        }

                })
            },
        downLoadData(){
                this.$Message.info(language.qingshaodeng)
                let paramsData = {
                deliveryPlan:"10",
                "categoryCode" : this.numpinzhong,
                "shopsign" : this.numpaihao,
                "thickness" : this.numhou,
                "length" : this.numchang,
                "width" : this.numkuan,
                "warehouseName" : this.numcangku,
                "serialCode" : this.numkunbaohao,
                "applyStatus" : this.cpyl,
                "outDeliveryDate":this.subData,
                "outStatus":this.chukuzhuangtai,
                "reelNo":this.mujuanchaxun,
                "rawPieceSpecdesc":this.guige,


                "stockDateFrom": this.paramssubData.subData,
                "stockDateTo": this.paramssubData.subData2,

                }
                axios({ 
                  method: 'post',
                  url: config.outlibraryExpt, 
                  data: paramsData, 
                  responseType: 'blob'
                }).then(function(response){
                    const content = response.data
                    const blob = new Blob([content])
                    const fileName = 'downLoad.xls'

                    if ('download' in document.createElement('a')) { // 非IE下载
                    // let that = this

                      const elink = document.createElement('a')
                      elink.download = fileName
                      elink.style.display = 'none'
                      elink.href = URL.createObjectURL(blob)
                      document.body.appendChild(elink)
                      elink.click()
                      URL.revokeObjectURL(elink.href) // 释放URL 对象
                      document.body.removeChild(elink)
                    } else { // IE10+下载
                      navigator.msSaveBlob(blob, fileName)
                    }

                })
                  .catch(function (error) {
                    console.log(error)
                  });
            },
            update(indexs){
                let that=this;

               // if(indexs = 1){
                let paramsData = {
                        "offset":"10",
                        "limit":"10",
                        "deliveryPlan":"10",
                        "categoryCode" : that.numpinzhong,
                        "shopsign" : that.numpaihao,
                        "thickness" : that.numhou,
                        "length" : that.numchang,
                        "width" : that.numkuan,
                        "warehouseName" : that.numcangku,
                        "serialCode" : that.numkunbaohao,
                        "applyStatus" : that.cpyl,
                        "outStatus":that.chukuzhuangtai,
                        "reelNo":that.mujuanchaxun,
                        "rawPieceSpecdesc":that.guige,
// 
                        "stockDateFrom" :that.paramssubData.subData,
                        "stockDateTo" :that.paramssubData.subData2,
                        // "applyStatus" : that.cpyl,
                        // "applyStatus" : that.cpyl,
                        // "deliveryPlan":"10"
                    }
                    // paramsData.stockDateFrom=that.paramssubData.subData;
                    // paramsData.stockDateTo=that.paramssubData.subData2;
                    // console.log(paramsData)
                  if(that.numbewdata.length%10 != 0){ that.moredata=false; return;}
                  return;
                  if(that.totalPageCount%10 == 0 && that.numbewdata.length == that.totalPageCount){ that.moredata=false; return;}
                 
                axios.post(config.queryOntOutApplyLine,paramsData).then(
                        function(response){ 

                            if(response.data.resultCode == 1){
                                // console.log(response)
                            that.numbewdata = that.numbewdata.concat(response.data.resultData.productList);
                            that.resl=response.data.page.totalWeight
                            that.$Message.info(language.jiazaiwanbi)
                            
                            }else{
                            that.$Message.info(response.data.fsuffix)
                            }
                           
                        })
                    // return
                // }
            },
            chongzhis(){
                let that = this;
                // console.log(that.numpinzhong)
                that.numpinzhong="";
                that.numpaihao="";
                that.numhou="";
                that.numchang="";
                that.numkuan="";
                that.numcangku="";
                that.numkunbaohao="";
                that.cpyl="";
                that.mujuanhaos="";
                that.subData="";
                that.paramssubData="";
                that.chukuzhuangtai="";
                that.mujuanchaxun="";
                that.guige="";
                // that.paramssubData.subData2=""
                // that.paramssubData.subData2="";
                // if(that.chongzhi==true){
                //     params.value=""
                // }
            },
            tiaozhuan(){
                this.$router.push({name: 'firstpage',params:{ id:'1'}});
            },
            srechEve(){
                // alert("aaa")
                let that = this;
                if(that.raval==false){
                    that.raval=true
                }else{
                    that.raval=false
                }

            },
            chaxun(){
                // alert(111)
                
                let that = this;
                that.$Message.info(language.qingshaodeng)
                let params={};
                params.categoryCode = that.numpinzhong;
                params.shopsign = that.numpaihao;
                params.thickness = that.numhou;
                params.length = that.numchang;
                params.width = that.numkuan;
                params.warehouseName = that.numcangku;
                params.serialCode = that.numkunbaohao;
                params.applyStatus = that.cpyl;
                params.stockDateFrom = that.paramssubData.subData;
                params.stockDateTo = that.paramssubData.subData2;
                params.deliveryPlan="10";
                params.outStatus=that.chukuzhuangtai;
                params.reelNo=that.mujuanchaxun;
                params.rawPieceSpecdesc=that.guige;
                // console.log( that.subData)
                axios.post(config.queryOntOutApplyLine,params).then(function(response){
                    if(response.data.resultCode==1){
                        that.numnum=response.data.page.totalPageCount
                        // console.log(response)
                        that.numbewdata=response.data.resultData.productList
                    that.modal1=false
                        that.resl=response.data.page.totalWeight
                        console.log(response)
                    // console.log(that.numbewdata)
                    }
                    // console.log(that.row.gcresourceCode)

                })

            },
            removelist(params){
                let that = this;
                let paramsData={
                        serialCode:params.row.serialCode,
                        applyId:params.row.applyId,
                        applySubid:params.row.applySubid
                }
                axios.post(config.cancleApplyPlan,paramsData).then(function(response){
                        console.log(response)
                        if(response.data.resultCode==1){
                            params.row.applyStatusName=language.chexiaochenggong
                            // console.log(params)
                            that.$Message.info(response.data.fsuffix)
                            that.ApplyLine()
                        }
                        if(response.data.resultCode==0){
                            that.$Message.info(response.data.fsuffix)
                            // console.log(params)
                        }

                })
            }
        },
        mounted(){
            this.ApplyLine()
            this.selectType()
            this.shopsignDrop()
            this.warehouseNameDrop()
        }
    }
</script>


// WEBPACK FOOTER //
// Original.vue?d1d400cc